import React, { useRef } from "react";
import {
  Container,
  FloatingLabel,
  Form,
  Button,
  Row,
  Col,
} from "react-bootstrap";
import emailjs from "emailjs-com";
import gif from "../../../images/mail.gif";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPaperPlane } from "@fortawesome/free-solid-svg-icons";

const ContactForm = () => {
  const title = {
    fontFamily: "'Satisfy', cursive",
    color: "#033d44",
  };
  const form = useRef();
  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_portfolio",
        "template_qwpmefx",
        form.current,
        "user_xwmNjhmsp4YgXtD8PUZ9g"
      )
      .then(
        (result) => {
          console.log(result.text);
        },
        (error) => {
          console.log(error.text);
        }
      );
    e.target.reset();
  };
  return (
    <Container className="p-4 my-3" id="form">
      <h1
        className="display-1 fw-bold ps-2 text-center pt-5 mt-5 mb-5 pb-4"
        style={title}
      >
        Contact Me
      </h1>
      <Row className="d-flex justify-content-center align-items-center">
        <Col xs={12} md={4} onLoadedMetadata={4}>
          <img src={gif} className="img-fluid pb-3" alt="" />
        </Col>
        <Col xs={12} md={8} style={{ MaxWidth: "400px" }}>
          <Container>
            <Form ref={form} onSubmit={sendEmail} className="bg-color p-5 ">
              <Row>
                <Col xs={12} md={6}>
                  <Form.Group className="mb-3">
                    <FloatingLabel
                      controlId="floatingInput"
                      label="Name"
                      className="mb-3"
                    >
                      <Form.Control
                        name="name"
                        type="text"
                        placeholder="Name"
                      />
                    </FloatingLabel>
                  </Form.Group>
                </Col>
                <Col xs={12} md={6}>
                  <Form.Group className="mb-3" controlId="formBasicEmail">
                    <FloatingLabel
                      controlId="floatingInput"
                      label="Email Address"
                      className="mb-3"
                    >
                      <Form.Control
                        name="email"
                        type="email"
                        placeholder="name@example.com"
                      />
                    </FloatingLabel>
                  </Form.Group>
                </Col>
              </Row>

              <Form.Group className="mb-3">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Subject"
                  className="mb-3"
                >
                  <Form.Control
                    name="subject"
                    type="text"
                    placeholder="Subject"
                  />
                </FloatingLabel>
              </Form.Group>

              <Form.Group className="mb-3" controlId="floatingTextarea">
                <FloatingLabel
                  controlId="floatingTextarea"
                  label="Message"
                  className="mb-3"
                >
                  <Form.Control
                    style={{ height: "85px" }}
                    name="message"
                    as="textarea"
                    placeholder="Leave a Message Here"
                  />
                </FloatingLabel>
              </Form.Group>
              <Button variant="outline-dark">
                <FontAwesomeIcon
                  style={{
                    color: "#033d44",
                    fontWeight: "bold",
                  }}
                  icon={faPaperPlane}
                />
                <input
                  style={{ backgroundColor: "#00000000" }}
                  className="border-0 custom-btn p-2"
                  type="submit"
                />
              </Button>
            </Form>
          </Container>
        </Col>
      </Row>
    </Container>
  );
};

export default ContactForm;
